import React from "react";
import { bulkEditExpenses } from "src/apiService/modules/transactions";
import { useRecordEvent } from "src/hooks/useRecordEvent";

import CommonBulkEditDialog, {
  BulkEditDialogText,
  BulkEditDialogTextList,
  BulkEditDialogTextListItem,
} from "src/components/BulkEditDialog";

interface BulkEditDialogProps {
  open: boolean;
  onClose: () => void;
}

function BulkEditDialog({ open, onClose }: BulkEditDialogProps) {
  const recordEvent = useRecordEvent();

  return (
    <CommonBulkEditDialog
      open={open}
      onClose={onClose}
      bulkEdit={(rows, metadata) => {
        recordEvent({
          type: "feature-adoption",
          feature: "bulk-edit",
          element: "expenses",
        });
        return bulkEditExpenses(rows, metadata);
      }}
      title="Bulk Edit Transactions"
      label="Click to Upload Transaction File"
    >
      <BulkEditDialogText>
        You can bulk edit transactions in My Reseller Genie by following these
        steps:
      </BulkEditDialogText>
      <BulkEditDialogTextList>
        <BulkEditDialogTextListItem>
          Filter for the transactions you want to edit
        </BulkEditDialogTextListItem>
        <BulkEditDialogTextListItem>
          Download the data by clicking the “Export” button on the table.
        </BulkEditDialogTextListItem>
        <BulkEditDialogTextListItem>
          Open the file and edit any fields that you’d like to change.
        </BulkEditDialogTextListItem>
        <BulkEditDialogTextListItem>
          Save the file and upload below.
        </BulkEditDialogTextListItem>
      </BulkEditDialogTextList>
    </CommonBulkEditDialog>
  );
}

export default BulkEditDialog;
